module.exports = __webpack_public_path__ + "static/media/wordmark_white.9fb4bb3f.svg";